import GlsActivationList from './GlsActivationList';
export default GlsActivationList;



// WEBPACK FOOTER //
// ./src/components/CaseBody/Activation/GlsActivationList/index.js